<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<!-- progress bar starts -->
<div class="background-style">
  <div class="progress ie-padding">
    <div class="circle done"> <span class="label">1</span>
      <p class="title-span-1">Site</p>
    </div> <span class="bar"><span class=" bar-done "></span></span>

    <div class="circle done"> <span class="label">2</span>
      <p class="title-span-2">BPG</p>
    </div> <span class="bar done"></span>


    <div class="circle"> <span class="label">3</span>
      <p class="title-span-3 ie-span-3">Areas of Impact</p>

    </div> <span class="bar"></span>

    <div class="circle"> <span class="label">4</span>
      <p class="title-span-4">Skills/interests</p>
</div>
    <!-- </div> <span *ngIf="!isCorporateUser" class="bar"></span> -->
    <!-- <div *ngIf="!isCorporateUser" class="circle"> <span class="label">5</span>
      <p class="title-span-5">Leadership</p>
    </div> -->
    <!-- <span class="bar"></span>

  <div class="circle"> <span class="label">5</span>
    <p class="title-span-5">Demographics</p>

  </div> -->
  </div>

  <!-- progress bar ends -->

  <!-- membership list starts -->
  <div class="noData" *ngIf="nobpgfound">No chapter created for your site</div>

  <div *ngIf="!nobpgfound" class="div">


    <div class="heading ">
      Please select desired Business Partnering Groups
    </div>

    <div class="notes">
      <em>
        <strong class="pr-1">Note:</strong>
      </em>
      <span>
        <em>Your existing BPG memberships are preselected here.</em>
      </span>
      <br>
      <div>You can either select and sign up for new BPGs or unselect the existing BPGs to withdraw membership.</div>
    </div>


    <div class="row music-covers-listing videos-list align-row width-horizontal">
      <div class="col-md-12 div-top" *ngFor="let bpgs of bpgList ; let i of index">
        <div class="font-family phone-style" > <label for="check{{bpgs.bpgName}}">
          <input type="checkbox" name="check{{bpgs.bpgName}}" [checked]="bpgs.checked" name="check{{bpgs.bpgName}}" id="check{{bpgs.bpgName}}" (change)="toggleCheckbox($event,bpgs)">
          <span class="label-text "></span></label>
        
          <span class="label-style checkbox-style">{{bpgs.bpgName}} </span>
           <p class="desc-style" [innerHtml]="bpgs.bpgDesc">
          </p> 
          </div>
       <div *ngIf = "(bpgs.showLeadership)">
        <div class="form font-family col-md-12 div-top leadership ">
          <p class="role-desc"><em>If interested to serve leadership position for {{bpgs.bpgName}}, then please select:</em></p>
          <label for="chairs{{bpgs.bpgName}}">
          <input type="checkbox"  name="chairs{{bpgs.bpgName}}" id="chairs{{bpgs.bpgName}}"  [checked]="bpgs.chairs" [(ngModel)]="chairs[bpgs.bpgName]"  (change)="assignroles($event,bpgs)">
          <span class="label-text "></span></label>
          <span class="label-style checkbox-style roles">Chair</span>
          <label for="viceChairs{{bpgs.bpgName}}">
          <input type="checkbox" name="viceChairs{{bpgs.bpgName}}" id="viceChairs{{bpgs.bpgName}}" [checked]="bpgs.viceChairs"  [(ngModel)]="viceChairs[bpgs.bpgName]" (change)="assignroles($event,bpgs)">
          <span class="label-text "></span></label>
          <span class="label-style checkbox-style roles">Vice Chair</span>
          <label for="communicationsChairs{{bpgs.bpgName}}">
          <input type="checkbox" name="communicationsChairs{{bpgs.bpgName}}" id="communicationsChairs{{bpgs.bpgName}}" [checked]="bpgs.communicationsChairs" [(ngModel)]="communicationsChairs[bpgs.bpgName]"  (change)="assignroles($event,bpgs)">
          <span class="label-text "></span></label>
          <span class="label-style checkbox-style roles">Communication Chair</span>
          <label for="financeChairs{{bpgs.bpgName}}">
          <input type="checkbox" name="financeChairs{{bpgs.bpgName}}" id="financeChairs{{bpgs.bpgName}}" [checked]="bpgs.financeChairs" [(ngModel)]="financeChairs[bpgs.bpgName]"  (change)="assignroles($event,bpgs)">
          <span class="label-text "></span>     </label>
          <span class="label-style checkbox-style roles">Finance Chair</span>
       </div>
</div>
      </div>
    </div>
    <p class="alert-class">{{message}}</p>
    <p class="top-space text-center padding-mid">
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 mr-4 font-family-button" routerLink='../site'
        (click)="redirectToSite()">BACK</button>
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button ml-4"
        (click)="sendData()">NEXT</button>
    </p>
  </div>
  <p class="top-space text-center padding-mid pt-4" *ngIf="nobpgfound">
    <button type="button" class="btn btn-danger col-sm-2 col-md-2 mr-4 font-family-button" routerLink='../site'
      (click)="redirectToSite()">BACK</button>
  </p>
  <!-- membership list ends -->
</div>
